import { Inject, Injectable, isDevMode, NgZone } from '@angular/core';
import { iif, Observable, of } from 'rxjs';
import { CONTENT_CACHE } from '../tokens';



@Injectable({
    providedIn: 'root'
})
export class ContentCache {

    private verbose = false;

    constructor(
        @Inject(CONTENT_CACHE) private contentCache: { [key: string]: any; },
        private ngZone: NgZone
    ) { }

    getOnceOrLoad(key: string, load: Observable<any>): Observable<any> {
        // const cached = { _meta: { alias: 'content-page' }, structuredDataJsonSchemas: [{ green: 'blue' }], };
        const cached = this.get(key);
        // if the cache contains a none null value, we use it otherwise we use load observable
        let response = of(cached);
        if (cached != null) {
            this.remove(key);
        } else {
            response = load;
        }
        return response;
    }

    getOrLoad(key: string, load: Observable<any>): Observable<any> {
        const cached = this.get(key);
        // if the cache contains a none null value, we use it otherwise we use load observable
        return iif(() => cached != null, of(cached), load);
    }

    get<T>(key: string): Partial<T> | null {
        return this.ngZone.runOutsideAngular(() => {
            const contentCache = this.contentCache;
            if (key != null && contentCache != null && contentCache[key] != null) {
                const cached = contentCache[key];

                if (this.verbose && isDevMode()) {
                    console.log(`Found ContentCache: '${key}'`, cached);
                }

                return cached as Partial<T>;
            }
            return null;
        });
    }

    private remove(key: string) {
        this.ngZone.runOutsideAngular(() => {
            const contentCache = this.contentCache;
            contentCache[key] = undefined;
        });
    }
}
